import type { PdfComponent } from '../../../TermsAndConditionsRender/components/typed';

export const SECTION2_1: PdfComponent = {
  type: 'section',
  id: 's3s2_1',
  title: '2.1 Online (Customer Not Present) Applications',
  content: [
    {
      type: 'altText',
      id: 's3s2_1heading',
      content: ['For online applications, the following must be observed:'],
      boldFirst: false,
    },
    {
      type: 'bulletList',
      id: 's3s2_1bullets',
      bulletType: 'alpha',
      content: [
        {
          copy: 'Permitted Goods and Services must be delivered to the Customer as stated in the Credit Agreement and to the specified address. In case of dispute, documentation confirming delivery may be requested.',
        },
        {
          copy: {
            type: 'altText',
            id: 's3s2_1goods',
            content: [
              'Goods or services must not be delivered until the credit application reaches the status ',
              'AWAITING FULFILMENT',
              '.',
            ],
            boldFirst: false,
          },
        },
        {
          copy: 'Kanda must notify the lender once the Customer has received their complete order (i.e., the order has been fulfilled).',
        },
        {
          copy: 'When notifying of fulfilment, Kanda must provide a valid reference or tracking number.',
        },
        {
          copy: 'Kanda must notify the lender immediately of any order cancellations, whether initiated by the Customer or the Retailer.',
        },
        {
          copy: 'Kanda must return any funds received for cancelled agreements without delay.',
        },
        {
          copy: 'Descriptions of Permitted Goods and Services must be clear, accurate, and submitted in the designated product description field.',
        },
        {
          copy: 'If flagged for fraud, Kanda must obtain and verify identity documents from the Customer (original passport or photocard driving licence) and ensure they match the Credit Agreement. Proof must be supplied upon request.',
        },
      ],
    },
  ],
};
